import { render, staticRenderFns } from "./fistipi.vue?vue&type=template&id=d48b257c&"
import script from "./fistipi.vue?vue&type=script&lang=js&"
export * from "./fistipi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports